var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 480",
    style: {
      enableBackground: "new 0 0 500 480"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A7A7A7;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "",
    transform: "translate(-59.000000, -560.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(56.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "multitasking-_x5B__x23_1440_x5D_",
    className: "st0",
    d: "M451,708.8c0,13-11.1,25.5-24.8,25.5h-24.7V543.8 c0-26.1-22.3-45.3-49.6-45.3H154V473c0-13,11-21.6,24.7-21.6h247.5c13.7,0,24.8,8.6,24.8,21.6V708.8z M352,805 c0,13-11.1,23.6-24.8,23.6H79.8C66.1,828.6,55,818,55,805V569.3c0-13,11.1-23.6,24.8-23.6h247.5c13.7,0,24.8,10.5,24.8,23.6V805z  M450.9,404.3H154c-27.4,0-49.5,19.2-49.5,45.3v49H55c-27.4,0-49.5,19.2-49.5,45.3v282.7c0,26.1,22.2,49.2,49.5,49.2h296.8 c27.4,0,49.6-23.1,49.6-49.2v-45.1h49.4c27.4,0,49.6-23.1,49.6-49.2V449.5C500.5,423.5,478.2,404.3,450.9,404.3L450.9,404.3z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockIcon);
export default __webpack_public_path__ + "static/media/block_icon.427ec24ae152e2871de327a57a6f301c.svg";
export { ForwardRef as ReactComponent };